import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import {
  Box,
  Container,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@material-ui/core';
import affiliateService from '../../services/affiliateService';

const AfiliadoAdd = () => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    name: '',
    platform: 'youtube',
    url: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await affiliateService.createChannel(formData, auth.token);

      if (response && response.data) {
        swal('Sucesso!', 'Canal cadastrado com sucesso! Aguarde aprovação do administrador.', 'success');
        navigate('/app/afiliados');
      } else {
        throw new Error('Erro ao criar canal');
      }
    } catch (error) {
      console.error(error);
      swal('Erro', 'Erro ao cadastrar canal', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Novo Canal | Sistema de Afiliados</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="lg">
          <form onSubmit={handleSubmit}>
            <Card>
              <CardHeader
                title="Cadastrar Novo Canal de Afiliado"
                subheader="Preencha as informações do seu canal para começar"
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Nome do Canal"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      variant="outlined"
                      helperText="Ex: Meu Canal do YouTube"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel>Plataforma</InputLabel>
                      <Select
                        label="Plataforma"
                        name="platform"
                        required
                        value={formData.platform}
                        onChange={handleChange}
                      >
                        <MenuItem value="youtube">YouTube</MenuItem>
                        <MenuItem value="instagram">Instagram</MenuItem>
                        <MenuItem value="tiktok">TikTok</MenuItem>
                        <MenuItem value="facebook">Facebook</MenuItem>
                        <MenuItem value="twitter">Twitter</MenuItem>
                        <MenuItem value="website">Website/Blog</MenuItem>
                        <MenuItem value="other">Outro</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="URL do Canal"
                      name="url"
                      value={formData.url}
                      onChange={handleChange}
                      variant="outlined"
                      helperText="Ex: https://youtube.com/@meucanal"
                      type="url"
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2,
                  gap: 2
                }}
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => navigate('/app/afiliados')}
                  disabled={loading}
                >
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Salvando...' : 'Cadastrar'}
                </Button>
              </Box>
            </Card>
          </form>
        </Container>
      </Box>
    </>
  );
};

export default AfiliadoAdd;
